import { Dialog } from 'primereact/dialog'
import classes from './FlexTemplateStepModal.module.scss'
import guides from '../../../utils/constants/guides'

interface FlexTemplateStepModalProps {
  onHide: () => void
  visible: boolean
  isCDPModal?: boolean
}

const FlexTemplateStepModal = ({
  onHide,
  visible,
  isCDPModal = false,
}: FlexTemplateStepModalProps) => {
  const footer = () => (
    <>
      <hr className={classes['modal-footer-hr']} />

      <div className={`${classes['dialog-footer']} ${classes['center-items']}`}>
        <button className={`${classes['dialog-close-btn']} ul-button -medium`} onClick={onHide}>
          CLOSE
        </button>
      </div>
    </>
  )

  const RenderCDPModalDisassociationGuide = () => {
    return (
      <>
        <div
          className={classes['modal-body']}
          style={{
            maxHeight: '60vh',
            overflowY: 'auto',
            padding: '1rem',
            width: '65vw',
          }}
        >
          <p>
            Ensure that your order line has the correct FLEX Template before creating a GMAWB
            project.
          </p>
          <p>If the FLEX Template is incorrect, follow these steps to update it in FLEX:</p>

          <ol>
            <li>
              Click the yellow warning indicator displayed within the GMAWB Template column for
              field rows with 'Not supported' value to open the FLEX Task Page in a new tab.
              <br />
              <img
                src={guides.CDPGuide1}
                alt="GMAWB Template Column"
                style={{
                  minHeight: '200px',
                  maxHeight: '250px',
                  marginTop: '10px',
                }}
              />
              <br />
              <i>
                <strong>Note: </strong>When cursor is hovered over the yellow warning indicator, a
                suggestion tooltip is displayed containing the required FLEX Template that supports
                the Choose Delivery Path combination you're attempting to use.
              </i>
              <br />
              <img
                src={guides.CDPGuide2}
                alt="Required FLEX Template"
                style={{
                  minHeight: '275px',
                  maxHeight: '300px',
                  marginTop: '10px',
                }}
              />
            </li>

            <li>
              Edit the FLEX Project, update the Project Template field with the correct FLEX
              Template, then save.
              <br />
              <br />
              <i>
                <strong>Note: </strong>Ensure you are the assigned FLEX Handler for this order line.
                Otherwise, assign FLEX Handler to yourself.
              </i>
              <br />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '10px',
                  marginTop: '10px',
                }}
              >
                <img
                  src={guides.Guide31}
                  alt="Edit FLEX Project - Step 1"
                  style={{ width: '100%', objectFit: 'contain' }}
                />
                <img
                  src={guides.Guide32}
                  alt="Edit FLEX Project - Step 2"
                  style={{
                    width: '100%',
                    maxHeight: '800px',
                    objectFit: 'contain',
                  }}
                />
              </div>
            </li>

            <li>
              Go to the FLEX Tasks Page and click <strong>'Disassociate a Template'</strong>,
              selecting the old FLEX Template.
              <br />
              <br />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '10px',
                  marginTop: '10px',
                }}
              >
                <img
                  src={guides.Guide41}
                  alt="Disassociate Template - Step 1"
                  style={{ width: '100%', objectFit: 'contain' }}
                />

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 10,
                    width: '50%',
                  }}
                >
                  <img
                    src={guides.Guide42}
                    alt="Disassociate Template - Step 2"
                    style={{
                      width: '100%',
                      maxHeight: '600px',
                      objectFit: 'contain',
                    }}
                  />
                  <img
                    src={guides.Guide43}
                    alt="Disassociate Template - Step 3"
                    style={{
                      width: '100%',
                      maxHeight: '600px',
                      objectFit: 'contain',
                    }}
                  />
                </div>
              </div>
            </li>

            <li>
              Close the Choose delivery path modal and return to GMAWB’s Project Work Queue Page,
              refresh the page, and wait for the FLEX synchronization to complete for your target
              project.
              <br />
              <br />
              &nbsp;{' '}
              <em>
                <strong>Note:</strong> Full synchronization will take a few minutes to complete
                before refreshing the PWQ page.
              </em>
              <br />
              <img
                src={guides.CDPGuide3}
                alt="Project Work Queue Page"
                style={{
                  minHeight: '300px',
                  maxHeight: '325px',
                  marginTop: '10px',
                }}
              />
            </li>

            <li>Once updated, you can proceed with GMAWB project creation.</li>
          </ol>
        </div>
      </>
    )
  }

  const RenderPWQModalDisassocitaionGuide = () => {
    return (
      <>
        <div
          className={classes['modal-body']}
          style={{
            maxHeight: '60vh',
            overflowY: 'auto',
            padding: '1rem',
            width: '65vw',
          }}
        >
          <p>
            Ensure that your order line has the correct FLEX Template before creating a GMAWB
            project.
          </p>
          <p>If the FLEX Template is incorrect, follow these steps to update it in FLEX:</p>

          <ol>
            <li>
              Ensure you are the assigned FLEX Handler for this order line. Otherwise, assign FLEX
              Handler to yourself.
              <br />
              <img
                src={guides.Guide1}
                alt="FLEX Handler Column"
                style={{
                  width: '100%',
                  maxHeight: '300px',
                  objectFit: 'contain',
                  marginTop: '10px',
                }}
              />
            </li>

            <li>
              Click the <strong>'FLEX'</strong> link to open the FLEX Tasks Page.
              <br />
              <img
                src={guides.Guide2}
                alt="FLEX Handler Column"
                style={{
                  width: '100%',
                  objectFit: 'contain',
                  marginTop: '10px',
                }}
              />
            </li>

            <li>
              Edit the FLEX Project, update the Project Template field with the correct FLEX
              Template, then save.
              <br />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '10px',
                  marginTop: '10px',
                }}
              >
                <img
                  src={guides.Guide31}
                  alt="Edit FLEX Project - Step 1"
                  style={{ width: '100%', objectFit: 'contain' }}
                />
                <img
                  src={guides.Guide32}
                  alt="Edit FLEX Project - Step 2"
                  style={{
                    width: '100%',
                    maxHeight: '800px',
                    objectFit: 'contain',
                  }}
                />
              </div>
            </li>

            <li>
              Go to the FLEX Tasks Page and click <strong>'Disassociate a Template'</strong>,
              selecting the old FLEX Template.
              <br />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '10px',
                  marginTop: '10px',
                }}
              >
                <img
                  src={guides.Guide41}
                  alt="Disassociate Template - Step 1"
                  style={{ width: '100%', objectFit: 'contain' }}
                />

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 10,
                    width: '50%',
                  }}
                >
                  <img
                    src={guides.Guide42}
                    alt="Disassociate Template - Step 2"
                    style={{
                      width: '100%',
                      maxHeight: '600px',
                      objectFit: 'contain',
                    }}
                  />
                  <img
                    src={guides.Guide43}
                    alt="Disassociate Template - Step 3"
                    style={{
                      width: '100%',
                      maxHeight: '600px',
                      objectFit: 'contain',
                    }}
                  />
                </div>
              </div>
            </li>

            <li>
              Return to GMAWB’s Project Work Queue Page, refresh the page, and wait for the FLEX
              synchronization to complete.
              <br />
              <br />
              &nbsp;{' '}
              <em>
                <strong>Note:</strong> Full synchronization will take a few minutes to complete
                before refreshing the PWQ page.
              </em>
            </li>

            <li>Once updated, you can proceed with GMAWB project creation.</li>
          </ol>
        </div>
      </>
    )
  }
  return (
    <Dialog
      className={classes['custom-dialog']}
      closable={true}
      draggable={false}
      resizable={false}
      header={'FLEX Template Disassociation Guide'}
      footer={footer}
      onHide={() => onHide && onHide()}
      visible={visible}
    >
      <hr className="modal-header-hr" />

      {isCDPModal ? RenderCDPModalDisassociationGuide() : RenderPWQModalDisassocitaionGuide()}
    </Dialog>
  )
}

export default FlexTemplateStepModal
